import React, { Component, Suspense } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Actions
import { setLoading, getEstablishments } from '../../store/actions/login/loginActions';
import { getPatientsManagementSearch, getPatientInfoManagement, getURItoUploadPhotoPatient, createPatient, updatePatient, deletePatient, deleteEpisode, deleteEpisodeAndInternment } from '../../store/actions/patientsManagement/patientsManagementActions';

//IMAGES
import noResults from '../../utils/es-no-results.svg';

// INSIDE COMPONENTS
import ContentHeaderTitle from '../../components/content_header_title/contentHeader';
import Content from '../../components/template/content';
import LoadingModal from '../../components/Loadings/LoadingModal';
import BackToTop from '../../components/BackToTop';
import WoundsSearch from '../Module_Wounds/Filters/woundsSearch';
import DialogPatientsForm from './DialogPatientsForm';
import PatientsGrid from './PatientsGrid';

//OUTSIDE COMPONENTS
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import Box from '@material-ui/core/Box';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

//CSS
import variables from '../../assets/bootstrap/scss/_variables.scss';

//UTIL
import { isDefined, resizeImageFn } from '../../utils/utils';
import { AZURE_CONTAINER_NAME } from '../../utils/constants';
import moment from 'moment';


//const PatientsGrid = React.lazy(() => import('./PatientsGrid'));

const primaryFont = variables;

const emptyPatient = {
    name: '',
    photoUri: '',
    identificationTypeId: 0,
    type: '',
    identification: '',
    birthDate: null,
    gender: '',
    career: '',
    nationality: '',
    clinicalHistory: '',
    episodes: [
        {
            bed: '',
            room: '',
            id: 0,
            patientID: 0,
            type: '',
            description: '',
            isClosed: false,
            entrydate: moment().format('YYYY/MM/DD'), //data Atual,
            exitDate: null,
            idIntern: 0
        }
    ]
};

class PatientsList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModalPatient: false,
            getPatientInProgress: false,
            isLoading: true,
            patientInfo: emptyPatient,
            patientID: 0,
            patientToSave: null,
            patientToSaveHavePhoto: false,
            patientSaveInProgress: false,
            goToNextStep: false,
            errorMessage: '',
            sucessMessage: '',
            showSucessMessage: false,
            showErrorMessage: false,
            patientToDelete: null,
            openDialogConfirmDeletePatient: false,
            openDialogConfirmDeleteEpisode: false,
            episodeToDelete: null,
            internmentToDelete: null,
            deleteEpisodeInProgress: false
        };

        this.handleCloseSnackBar = this.handleCloseSnackBar.bind(this);
    }

    componentDidMount() {
        if (this.props.login.validToken) {
      /* && !this.props.patient.TokenRefresh && !this.props.wounds.TokenRefresh */ var dataFilter = {
                Order: this.props.patientsManage.Order,
                PropertyOrder: this.props.patientsManage.PropertyOrder,
                NumberOfRecordsPerPage: this.props.patientsManage.NumberRowsPerPage,
                Page: this.props.patientsManage.Page
            };
            this.props.patientsManage.isLoading = true;
            this.props.patientsManage.getPatientsInProgress = true;
            this.props.patientsManage.NumberOfRecords = 0;
            this.props.getPatientsManagementSearch(dataFilter);
        }
    }

    componentDidUpdate() {
        const {
            TokenRefresh,
            Refresh,
            listPatients,
            Order,
            PropertyOrder,
            NumberRowsPerPage,
            Page,
            isLoading,
            PatientInfo,
            PatientID,
            createPatientInProgress,
            PatientsProcessErrorMessage,
            stepsCreatePatient,
            getPatientsInProgress,
            deletePatientSucess,
            deleteEpisodeSucess,
            deleteEpisodeErrorMessage
        } = this.props.patientsManage;
        const { validToken, establishments, establishmentsInProgress } = this.props.login;

        if (validToken && !TokenRefresh) {
            if ((Refresh || !isDefined(listPatients)) && !getPatientsInProgress) {
                var dataFilter = {
                    Order: Order,
                    PropertyOrder: PropertyOrder,
                    NumberOfRecordsPerPage: NumberRowsPerPage,
                    Page: Page
                };

                /*                 if (this.timeout) clearTimeout(this.timeout);
                                        this.timeout = setTimeout(() => { */
                this.props.patientsManage.isLoading = true;
                this.props.patientsManage.getPatientsInProgress = true;
                this.props.getPatientsManagementSearch(dataFilter);
                /* }, 300); */
            } else if (!isDefined(establishments) && !establishmentsInProgress) {
                this.props.login.establishmentsInProgress = true;
                this.props.getEstablishments();
            } else if (this.state.getPatientInProgress) {
                if (isDefined(PatientInfo)) {
                    let patient = {
                        name: PatientInfo.name,
                        photoUri: PatientInfo.photoURI,
                        identificationTypeId: PatientInfo.identificationTypeId,
                        identification: PatientInfo.identification,
                        type: PatientInfo.type,
                        birthDate: PatientInfo.birthDate,
                        gender: PatientInfo.gender,
                        career: PatientInfo.career,
                        nationality: PatientInfo.nationality,
                        clinicalHistory: PatientInfo.clinicalHistory,
                        episodes: this.mergeEpisodesAndInternment() //this.props.patientsManage.PatientEpisodes
                    };
                    this.setState({
                        getPatientInProgress: false,
                        showModalPatient: true,
                        patientInfo: patient,
                        patientID: PatientID
                    });
                }
            } else if (this.state.patientSaveInProgress) {
                if (createPatientInProgress) {
                    if (PatientsProcessErrorMessage != '') {
                        let msg = PatientsProcessErrorMessage;
                        this.props.patientsManage.createPatientInProgress = false;
                        this.props.patientsManage.PatientsProcessErrorMessage = '';
                        this.setState({
                            isLoading: false,
                            showErrorMessage: true,
                            errorMessage: msg,
                            patientSaveInProgress: false,
                            goToNextStep: false
                        });
                    } else if (stepsCreatePatient == 'updloadPhoto') {
                        if (this.state.goToNextStep) {
                            if (!isDefined(this.state.patientToSave.ID)) {
                                this.props.createPatient(this.state.patientToSave);
                            } else {
                                this.props.updatePatient(this.state.patientToSave);
                            }
                        } else {
                            this.uploadPhotoPatient();
                        }
                    } else if (stepsCreatePatient == 'savePatient') {
                        if (!isDefined(this.state.patientToSave.ID)) {
                            this.props.createPatient(this.state.patientToSave);
                        } else {
                            this.props.updatePatient(this.state.patientToSave);
                        }
                    } else if (stepsCreatePatient == 'savePatientDone') {
                        this.setState({
                            isLoading: true,
                            showSucessMessage: true,
                            sucessMessage: 'sucessChangesSaved',
                            patientSaveInProgress: false,
                            showModalPatient: false,
                            patientInfo: emptyPatient,
                            patientID: 0,
                            goToNextStep: false,
                            patientToSave: null
                        });
                        this.props.patientsManage.createPatientInProgress = false;
                        this.props.patientsManage.PatientsProcessErrorMessage = '';
                        this.props.patientsManage.stepsCreatePatient = '';
                        this.props.patientsManage.PatientID = 0;
                        this.props.patientsManage.PatientInfo = null;
                        this.props.patientsManage.Refresh = true;

                        //this.closePatientModal();
                    }
                } else {
                    if (this.state.patientToSaveHavePhoto) {
                        this.props.getURItoUploadPhotoPatient(
                            this.state.patientToSave.IdentificationTypeId +
                            '_' +
                            this.state.patientToSave.Identification
                        );
                    } else {
                        // Passa logo para a criação/atualização do utente...
                        if (!isDefined(this.state.patientToSave.ID)) {
                            this.props.createPatient(this.state.patientToSave);
                        } else {
                            this.props.updatePatient(this.state.patientToSave);
                        }
                    }
                }
            } else if (deletePatientSucess === true) {
                this.props.patientsManage.deletePatientSucess = null;
                this.props.patientsManage.Refresh = true;
                this.setState({
                    isLoading: true,
                    openDialogConfirmDeletePatient: false,
                    showSucessMessage: true,
                    sucessMessage: 'sucess_default'
                });
            } else if (deletePatientSucess === false) {
                this.props.patientsManage.deletePatientSucess = null;
                this.setState({
                    openDialogConfirmDeletePatient: false,
                    showErrorMessage: true,
                    errorMessage: 'error_default'
                });
            } else if (this.state.deleteEpisodeInProgress) {
                if (deleteEpisodeSucess) {
                    let list = this.state.patientInfo.episodes;
                    let numEpisodes = list.length;

                    for (let i = 0; i < numEpisodes; i++) {
                        if (list[i].id == this.state.episodeToDelete) {
                            list[i].delete = true;
                            break;
                        }
                    }

                    let patient = {
                        name: this.state.patientInfo.name,
                        photoUri: this.state.patientInfo.photoUri,
                        identificationTypeId: this.state.patientInfo.identificationTypeId,
                        identification: this.state.patientInfo.identification,
                        type: this.state.patientInfo.type,
                        birthDate: this.state.patientInfo.birthDate,
                        gender: this.state.patientInfo.gender,
                        career: this.state.patientInfo.career,
                        nationality: this.state.patientInfo.nationality,
                        clinicalHistory: this.state.patientInfo.clinicalHistory,
                        episodes: list
                    };

                    this.setState({
                        patientInfo: patient,
                        openDialogConfirmDeleteEpisode: !this.state.openDialogConfirmDeleteEpisode,
                        episodeToDelete: null,
                        internmentToDelete: null,
                        deleteEpisodeInProgress: false,
                        showSucessMessage: true,
                        sucessMessage: 'sucess_default'
                    });
                } else if (!deleteEpisodeSucess && isDefined(deleteEpisodeErrorMessage)) {
                    this.setState({
                        openDialogConfirmDeleteEpisode: !this.state.openDialogConfirmDeleteEpisode,
                        episodeToDelete: null,
                        internmentToDelete: null,
                        deleteEpisodeInProgress: false,
                        showErrorMessage: true,
                        errorMessage: deleteEpisodeErrorMessage
                    })
                }
            } else if (this.state.isLoading) {
                this.setState({ isLoading: false });
            }
        }
    }

    mergeEpisodesAndInternment() {
        let listEpisodes = this.props.patientsManage.PatientEpisodes;
        let listInt = this.props.patientsManage.PatientInfo.internment;

        for (let i = 0; i < listEpisodes.length; i++) {
            if (listEpisodes[i].type === 'inPatient') {
                for (let j = 0; j < listInt.length; j++) {
                    let dataInt = moment(listInt[j].entryDate);
                    let dataEp = moment(listEpisodes[i].entrydate);
                    if (dataInt.diff(dataEp, 'days') == 0) {
                        listEpisodes[i].room = listInt[j].room;
                        listEpisodes[i].bed = listInt[j].bed;
                        listEpisodes[i].idIntern = listInt[j].id;
                        break;
                    }
                }
            }
            if (!isDefined(listEpisodes[i].delete)) {
                listEpisodes[i].delete = false;
            }
        }

        // ordernar os episodio:
        // 1º os abertos, os mais recentes 1º
        // 2º os fechados, ordenados pela data de fecho mais recente
        listEpisodes.sort((a, b) =>
            a.isClosed && !b.isClosed
                ? 1
                : !a.isClosed && b.isClosed
                    ? -1
                    : a.isClosed && b.isClosed
                        ? a.exitDate < b.exitDate
                            ? 1
                            : b.exitDate < a.exitDate
                                ? -1
                                : 0
                        : a.entrydate < b.entrydate
                            ? 1
                            : b.entrydate < a.entrydate
                                ? -1
                                : 0
        );

        return listEpisodes;
    }

    onSearchChanged(patientID) {
        // tem um utente selecionado
        // Deve abrir a modal de alteração do utente

        if (patientID > 0) {

            this.props.patientsManage.PatientID = patientID;
            this.props.getPatientInfoManagement(patientID);

            this.setState({
                getPatientInProgress: true,
                isLoading: true
            });
        }
    }

    addPatient() {
        this.setState({
            showModalPatient: true,
            patientInfo: emptyPatient,
            patientID: 0
        });
    }

    onDeletePatient(id) {
        // show Message to confirm delete user from institution
        this.setState({
            openDialogConfirmDeletePatient: !this.state.openDialogConfirmDeletePatient,
            patientToDelete: id
        });
    }

    onDeletePatientConfirm() {
        this.props.deletePatient(this.state.patientToDelete);
    }

    onPatientSelected() {
        if (this.props.patientsManage.PatientID > 0) {

            this.props.getPatientInfoManagement(this.props.patientsManage.PatientID);
            this.setState({
                isLoading: true,
                getPatientInProgress: true
            });
        }
    }

    onFilterChanged() {
        if (this.props.patientsManage.Refresh) {
            this.setState({ isLoading: true });

            var dataFilter = {
                Order: this.props.patientsManage.Order,
                PropertyOrder: this.props.patientsManage.PropertyOrder,
                NumberOfRecordsPerPage: this.props.patientsManage.NumberRowsPerPage,
                Page: this.props.patientsManage.Page
            };
            window.scrollTo(0, 0);
            this.props.patientsManage.isLoading = true;
            this.props.patientsManage.listPatients = [];
            if (this.timeout) clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                //search function
                this.props.getPatientsManagementSearch(dataFilter);
            }, 300);
        }
    }

    closePatientForm(showMessage) {
        if (showMessage) {
            this.setState({
                openDialogConfirmCancelPatient: true
            });
        } else {
            this.closePatientModal();
        }
    }

    closePatientModal() {
        this.setState({
            showModalPatient: false,
            openDialogConfirmCancel: false,
            openDialogConfirmCancelPatient: false,
            patientInfo: emptyPatient,
            patientID: 0
        });

        this.props.patientsManage.PatientID = 0;
        this.props.patientsManage.PatientInfo = null;
        this.props.patientsManage.Refresh = true;
    }

    closeDialogDelete() {
        this.setState({
            openDialogConfirmDeletePatient: false,
            openDialogConfirmDeleteEpisode: false,
            patientToDelete: null,
            episodeToDelete: null,
            internmentToDelete: null,
            deleteEpisodeInProgress: false
        });
    }

    closeDialogCancel() {
        this.setState({
            openDialogConfirmCancel: false,
            openDialogConfirmCancelPatient: false
        });
    }

    savePatient(value) {
        let patientToSave;

        //VALIDATE IF THE INFO PATIENT IS CHANGED
        //let patientBeforeChange = this.props.patientsManage.PatientInfo;
        let patientAfterChange = value;

        let listBeforeChange = this.props.patientsManage.PatientEpisodes;
        let listAfterChange = value.episodes;
        let listEpisodesToSave = [];
        let listInternToSave = [];
        let numAfter = listAfterChange.length;
        let numBefore = listBeforeChange.length;
        let internBefore = [];
        if (isDefined(this.props.patientsManage.PatientInfo)) {
            internBefore = this.props.patientsManage.PatientInfo.internment;
        }
        let listEpisodesToDelete = [];

        for (let i = 0; i < numAfter; i++) {
            let epAfter = listAfterChange[i];

            if (!epAfter.delete) {
                if (epAfter.id > 0) {
                    // O episodio já existia, tem que mandar os ids...
                    let episodio = epAfter;

                    if (epAfter.type == 'inPatient') {
                        //passar todos os campos do episodio, e adicionar o estabelecimento
                        if (isDefined(epAfter.exitDate) && epAfter.exitDate !== '') {
                            episodio = {
                                id: epAfter.id,
                                bed: epAfter.bed,
                                room: epAfter.room,
                                type: epAfter.type,
                                description: epAfter.description,
                                isClosed: epAfter.isClosed,
                                entrydate: moment(epAfter.entrydate).format('YYYY-MM-DD'),
                                exitDate: moment(epAfter.exitDate).format('YYYY-MM-DD'),
                                EstablishmentId: this.props.patientsManage.establishmentDefault
                            };
                        } else {
                            episodio = {
                                id: epAfter.id,
                                bed: epAfter.bed,
                                room: epAfter.room,
                                type: epAfter.type,
                                description: epAfter.description,
                                isClosed: epAfter.isClosed,
                                entrydate: moment(epAfter.entrydate).format('YYYY-MM-DD'),
                                EstablishmentId: this.props.patientsManage.establishmentDefault
                            };
                        }

                        // Procurar o internamento antes das alterações que corresponde
                        for (let j = 0; j < numBefore; j++) {
                            let epBefore = listBeforeChange[j];

                            if (epAfter.id === epBefore.id) {
                                //Procurar o internamento correspondente de acordo com as datas antes da alteração
                                for (let k = 0; k < internBefore.length; k++) {
                                    /* let dataInt = moment(internBefore[k].entryDate);
                                    let dataEp = moment(epBefore.entrydate); */

                                    //if (dataInt.diff(dataEp, 'days') == 0) {
                                    if (internBefore[k].id == epBefore.idIntern) {
                                        // É este o internamento....
                                        let intern;
                                        if (isDefined(epAfter.exitDate) && epAfter.exitDate !== '') {
                                            intern = {
                                                id: internBefore[k].id,
                                                patientId: internBefore[k].patientId,
                                                room: epAfter.room,
                                                bed: epAfter.bed,
                                                entryDate: moment(epAfter.entrydate).format('YYYY-MM-DD'),
                                                exitDate: moment(epAfter.exitDate).format('YYYY-MM-DD'),
                                                isInternee: true,
                                                patientSns: internBefore[k].patientSns
                                            };
                                        } else {
                                            intern = {
                                                id: internBefore[k].id,
                                                patientId: internBefore[k].patientId,
                                                room: epAfter.room,
                                                bed: epAfter.bed,
                                                entryDate: moment(epAfter.entrydate).format('YYYY-MM-DD'),
                                                isInternee: true,
                                                patientSns: internBefore[k].patientSns
                                            };
                                        }
                                        listInternToSave = listInternToSave.concat(intern);
                                        break;
                                    }
                                }
                                break;
                            }
                        }
                    } else {
                        if (isDefined(epAfter.exitDate) && epAfter.exitDate !== '') {
                            episodio = {
                                id: epAfter.id,
                                bed: epAfter.bed,
                                room: epAfter.room,
                                type: epAfter.type,
                                description: epAfter.description,
                                isClosed: epAfter.isClosed,
                                entrydate: moment(epAfter.entrydate).format('YYYY-MM-DD'),
                                exitDate: moment(epAfter.exitDate).format('YYYY-MM-DD')
                            };
                        } else {
                            episodio = {
                                id: epAfter.id,
                                bed: epAfter.bed,
                                room: epAfter.room,
                                type: epAfter.type,
                                description: epAfter.description,
                                isClosed: epAfter.isClosed,
                                entrydate: moment(epAfter.entrydate).format('YYYY-MM-DD')
                            };
                        }
                    }

                    listEpisodesToSave = listEpisodesToSave.concat(episodio);
                } else {
                    // novo episodio e internamento, logo não pode enviar os ids
                    let episodio = epAfter;

                    if (epAfter.type == 'inPatient') {
                        let intern;
                        if (isDefined(epAfter.exitDate) && epAfter.exitDate !== '') {
                            episodio = {
                                bed: epAfter.bed,
                                room: epAfter.room,
                                type: epAfter.type,
                                description: epAfter.description,
                                isClosed: epAfter.isClosed,
                                entrydate: moment(epAfter.entrydate).format('YYYY-MM-DD'),
                                exitDate: moment(epAfter.exitDate).format('YYYY-MM-DD'),
                                EstablishmentId: this.props.patientsManage.establishmentDefault
                            };

                            intern = {
                                room: epAfter.room,
                                bed: epAfter.bed,
                                entryDate: moment(epAfter.entrydate).format('YYYY-MM-DD'),
                                exitDate: moment(epAfter.exitDate).format('YYYY-MM-DD'),
                                isInternee: true,
                                patientSns: 0
                            };
                        } else {
                            episodio = {
                                bed: epAfter.bed,
                                room: epAfter.room,
                                type: epAfter.type,
                                description: epAfter.description,
                                isClosed: epAfter.isClosed,
                                entrydate: moment(epAfter.entrydate).format('YYYY-MM-DD'),
                                EstablishmentId: this.props.patientsManage.establishmentDefault
                            };

                            intern = {
                                room: epAfter.room,
                                bed: epAfter.bed,
                                entryDate: moment(epAfter.entrydate).format('YYYY-MM-DD'),
                                isInternee: true,
                                patientSns: 0
                            };
                        }


                        listInternToSave = listInternToSave.concat(intern);
                    } else {
                        if (isDefined(epAfter.exitDate) && epAfter.exitDate !== '') {
                            episodio = {
                                type: epAfter.type,
                                description: epAfter.description,
                                isClosed: epAfter.isClosed,
                                entrydate: moment(epAfter.entrydate).format('YYYY-MM-DD'),
                                exitDate: moment(epAfter.exitDate).format('YYYY-MM-DD')
                            };
                        } else {
                            episodio = {
                                type: epAfter.type,
                                description: epAfter.description,
                                isClosed: epAfter.isClosed,
                                entrydate: moment(epAfter.entrydate).format('YYYY-MM-DD')
                            };
                        }
                    }

                    listEpisodesToSave = listEpisodesToSave.concat(episodio);
                }
            } else {
                if (epAfter.id > 0) {
                    listEpisodesToDelete = listEpisodesToDelete.concat(epAfter.id)
                }
            }
        }

        if (this.state.patientID > 0) {
            patientToSave = {
                ID: this.state.patientID,
                IdentificationTypeId: patientAfterChange.identificationTypeId,
                Identification: patientAfterChange.identification,
                Name: patientAfterChange.name,
                Gender: patientAfterChange.gender,
                BirthDate: moment(patientAfterChange.birthdate).format('YYYY-MM-DD'),
                Career: patientAfterChange.career,
                ClinicalHistory: patientAfterChange.clinicalHistory,
                Nationality: patientAfterChange.nationality,
                PhotoURI: '',
                Internment: listInternToSave,
                Episode: listEpisodesToSave
            };
        } else {
            if (listInternToSave.length > 0) {
                patientToSave = {
                    IdentificationTypeId: patientAfterChange.identificationTypeId,
                    Identification: patientAfterChange.identification,
                    Name: patientAfterChange.name,
                    Gender: patientAfterChange.gender,
                    BirthDate: moment(patientAfterChange.birthdate).format('YYYY-MM-DD'),
                    Career: patientAfterChange.career,
                    ClinicalHistory: patientAfterChange.clinicalHistory,
                    Nationality: patientAfterChange.nationality,
                    PhotoURI: '',
                    Internment: listInternToSave,
                    Episode: listEpisodesToSave
                };
            } else {
                patientToSave = {
                    IdentificationTypeId: patientAfterChange.identificationTypeId,
                    Identification: patientAfterChange.identification,
                    Name: patientAfterChange.name,
                    Gender: patientAfterChange.gender,
                    BirthDate: moment(patientAfterChange.birthdate).format('YYYY-MM-DD'),
                    Career: patientAfterChange.career,
                    ClinicalHistory: patientAfterChange.clinicalHistory,
                    Nationality: patientAfterChange.nationality,
                    PhotoURI: '',
                    Episode: listEpisodesToSave
                };
            }
        }

        let havePhoto = false;
        if (document.getElementById('fileinputPatient') !== null) {
            var file = document.getElementById('fileinputPatient').files[0];

            if (file !== undefined) {
                havePhoto = true;
            }
        }
        this.setState({
            patientToSave: patientToSave,
            isLoading: true,
            patientToSaveHavePhoto: havePhoto,
            patientSaveInProgress: true,
            goToNextStep: false
        });
    }

    addEpisodeToPatient(episode) {
        let list = this.state.patientInfo.episodes;

        let newEpisd = [
            {
                id: 0,
                patientID: this.state.patientID,
                type: episode.type,
                description: '',
                isClosed: false,
                entrydate: moment().format('YYYY/MM/DD'), //data Atual,
                exitDate: null
            }
        ];
        //list = newEpisd.concat(list);
        list = list.concat(newEpisd);

        let patient = {
            name: this.state.patientInfo.name,
            photoUri: this.state.patientInfo.photoUri,
            identificationTypeId: this.state.patientInfo.identificationTypeId,
            identification: this.state.patientInfo.identification,
            type: this.state.patientInfo.type,
            birthDate: this.state.patientInfo.birthDate,
            gender: this.state.patientInfo.gender,
            career: this.state.patientInfo.career,
            nationality: this.state.patientInfo.nationality,
            clinicalHistory: this.state.patientInfo.clinicalHistory,
            episodes: list
        };

        this.setState({
            patientInfo: patient
        });
    }

    async uploadPhotoPatient() {
        let patient = this.state.patientToSave;
        if (document.getElementById('fileinputPatient') !== null) {
            var file = document.getElementById('fileinputPatient').files[0];

            if (file !== undefined) {
                let fileResize = file;
                fileResize = await resizeImageFn(file);
                var customBlockSize = 1024 * 512;
                //var customBlockSize = 512 * 256;

                var host = this.props.patientsManage.PatientPhotoURI;
                host = host.split(AZURE_CONTAINER_NAME)[0];
                var sasToken = this.props.patientsManage.PatientPhotoURI;
                sasToken = sasToken.split('?')[1];
                var fileBlob = this.props.patientsManage.PatientPhotoURI;
                fileBlob = fileBlob.split(AZURE_CONTAINER_NAME + '/')[1];
                fileBlob = fileBlob.split('?')[0];
                //fileBlob = fileBlob + '/' + this.props.patientsManage.PatientPhotoFileName + '.jpg'

                var blobService = window.AzureStorage.Blob.createBlobServiceWithSas(
                    host,
                    sasToken
                );
                blobService.singleBlobPutThresholdInBytes = customBlockSize;

                var speedSummary = blobService.createBlockBlobFromBrowserFile(
                    AZURE_CONTAINER_NAME,
                    fileBlob,
                    fileResize,
                    function (error, result, response) {
                        // apresentar o erro
                        if (error) {
                        }
                    }
                );
            }

            if (isDefined(this.props.patientsManage.PatientPhotoURI)) {
                if (isDefined(this.state.patientToSave.PhotoURI)) {
                    if (
                        this.state.patientToSave.PhotoURI !==
                        this.props.patientsManage.PatientPhotoURI
                    ) {
                        patient.PhotoURI = this.props.patientsManage.PatientPhotoURI.split('?')[0];
                    }
                }
            }
        }

        this.setState({
            patientToSave: patient,
            goToNextStep: true
        });
    }

    deleteEpisode(id, idInt) {
        // show Message to confirm delete user from institution
        this.setState({
            openDialogConfirmDeleteEpisode: !this.state.openDialogConfirmDeleteEpisode,
            episodeToDelete: id,
            internmentToDelete: idInt
        });
    }

    onDeleteEpisodeConfirm() {

        if (this.state.internmentToDelete > 0) {
            this.props.deleteEpisodeAndInternment(this.state.episodeToDelete, this.state.internmentToDelete)
        } else {
            this.props.deleteEpisode(this.state.episodeToDelete)
        }
        this.setState({
            deleteEpisodeInProgress: true
        })
    }

    onChangeEpisodesDate(type, id, value) {

        let list = this.state.patientInfo.episodes;
        let numEpisodes = list.length;
        let refresh = false;

        for (let i = 0; i < numEpisodes; i++) {
            if (list[i].id == id) {
                if (type == 'entry') {
                    if (isDefined(value)) {
                        list[i].entrydate = moment(value);
                    } else {
                        list[i].entrydate = null;
                    }
                } else {
                    if (isDefined(value)) {
                        list[i].exitDate = moment(value);
                        list[i].isClosed = true;
                    } else {
                        list[i].exitDate = null;
                        list[i].isClosed = false;
                    }
                }
                refresh = true;
                break;
            }
        }

        if (refresh) {
            let patient = {
                name: this.state.patientInfo.name,
                photoUri: this.state.patientInfo.photoUri,
                identificationTypeId: this.state.patientInfo.identificationTypeId,
                identification: this.state.patientInfo.identification,
                type: this.state.patientInfo.type,
                birthDate: this.state.patientInfo.birthDate,
                gender: this.state.patientInfo.gender,
                career: this.state.patientInfo.career,
                nationality: this.state.patientInfo.nationality,
                clinicalHistory: this.state.patientInfo.clinicalHistory,
                episodes: list
            };

            this.setState({
                patientInfo: patient
            });
        }
    }

    handleCloseSnackBar() {
        this.setState({
            showSucessMessage: false,
            showErrorMessage: false
        });
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <div id='back-to-top-patientslist'></div>
                <div className='container pb-5' id='div-patients-list'>
                    <Row className='pb-3'>
                        <Col /* sm={12} lg={9} */>
                            <Row className='pb-3 pb-md-3 pb-lg-3 no-gutters'>
                                <div className='my-auto order-sm-first d-none d-md-block pl-md-0 pl-3 pr-4'>
                                    <ContentHeaderTitle
                                        fontFamily='Nunito'
                                        classes='d-inline text-uppercase title-search pr-md-4 pr-lg-0'
                                        title={t('PatientsTitle')}
                                    />
                                </div>
                                <Col
                                    xs={10}
                                    sm={10}
                                    md
                                    lg
                                    xl
                                    className='pl-lg-4 pl-md-2 pl-0 pt-2 pt-md-0 my-sm-auto order-lg-last order-md-last'
                                >
                                    <WoundsSearch selectPatient={(a) => this.onSearchChanged(a)}>
                                        {this.props}
                                    </WoundsSearch>
                                </Col>
                                <Col md={1} xs={2} className='my-auto order-last text-right'>
                                    <IconButton
                                        color='primary'
                                        className='add-icon outline-none p-0'
                                        onClick={() => this.addPatient()}
                                        disabled={this.state.isLoading}
                                    >
                                        <PersonAddIcon fontSize='large'></PersonAddIcon>
                                    </IconButton>
                                </Col>
                            </Row>
                            <Content>
                                {this.props.patientsManage.NumberOfRecords == 0 &&
                                    isDefined(this.props.patientsManage.listPatients) &&
                                    !this.state.isLoading &&
                                    !this.props.patientsManage.Refresh ? (
                                    <div className='text-center my-5 py-5'>
                                        <Image
                                            className={`empty-state-patient-table pt-4`}
                                            fluid
                                            alt='empty state'
                                            src={noResults}
                                        ></Image>
                                        <Box
                                            className='pt-2'
                                            fontFamily={primaryFont}
                                            fontWeight={700}
                                            fontSize={15}
                                        >
                                            {t('EmptyStates.NoResults')}
                                        </Box>
                                        <Box fontFamily={primaryFont} fontSize={12}>
                                            {t('EmptyStates.TryFilter')}
                                        </Box>
                                    </div>
                                ) : (
                                    <>
                                        <div className='d-flex'>
                                            <Box
                                                className='flex-fill opacity-50 number-of-records pt-3'
                                                color='text'
                                                fontSize={10}
                                                lineHeight={1.4}
                                                textAlign='left'
                                            >
                                                {this.props.patientsManage.NumberOfRecords}{' '}
                                                {this.props.patientsManage.NumberOfRecords > 1
                                                    ? t('WoundsPage.PatientsList')
                                                    : t('WoundsPage.PatientList')}
                                            </Box>
                                        </div>

                                        <LoadingModal
                                            hidden={
                                                !this.state.isLoading &&
                                                !this.props.patientsManage.getPatientsInProgress
                                            }
                                            isFixed={true}
                                        />
                                        {/* <Suspense fallback={<LoadingModal />}> */}
                                        <PatientsGrid
                                            isLoading={this.state.isLoading}
                                            searchData={this.props.getPatientsHistoryInterventions}
                                            selectPatient={() => this.onPatientSelected()}
                                            deletePatient={(id) => this.onDeletePatient(id)}
                                            changeOrder={() => this.onFilterChanged()}
                                        >
                                            {this.props}
                                        </PatientsGrid>
                                        {/*  </Suspense> */}
                                    </>
                                )}
                            </Content>
                        </Col>
                    </Row>
                </div>

                {/* Modal Add/Change User*/}
                <DialogPatientsForm
                    showPatientInfoModal={this.state.showModalPatient}
                    onClose={(v) => this.closePatientForm(v)}
                    savePatient={(v) => this.savePatient(v)}
                    editMode={this.state.patientID > 0}
                    patientInfo={this.state.patientInfo}
                    onAddEpisodeToPatient={(v) => this.addEpisodeToPatient(v)}
                    saveInProgress={
                        this.props.login.createUserInProgress || this.state.patientSaveInProgress
                    }
                    isLoading={this.state.isLoading}
                    onChangeEpisodesDate={(type, id, value) =>
                        this.onChangeEpisodesDate(type, id, value)
                    }
                    identificationTypes={this.props.patientsManage.identificationTypes}
                    onDeleteEpisode={(id, idInt) => this.deleteEpisode(id, idInt)}
                />

                {/* DIALOG CONFIRM CANCEL PATIENT FORM*/}
                <Dialog
                    open={this.state.openDialogConfirmCancelPatient}
                    className='admin-modals'
                    aria-labelledby='alert-dialog-title'
                    aria-describedby='alert-dialog-description'
                >
                    <DialogContent className='pb-0 px-4'>
                        <DialogContentText id='alert-dialog-confirm-cancel'>
                            {t('loseUnsavedChanges')}
                            {' ' + t('confirmQuestion')}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions className='pt-0 pr-4'>
                        <Button
                            className='outline-none'
                            onClick={(v) => this.closeDialogCancel()}
                            color='#494949'
                            autoFocus
                            disableFocusRipple
                            disableElevation
                            disableRipple
                        >
                            {t('No')}
                        </Button>
                        <Button
                            className='outline-none'
                            onClick={(v) => this.closePatientModal()}
                            color='primary'
                            disableFocusRipple
                            disableElevation
                            disableRipple
                        >
                            {t('Yes')}
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* DIALOG MSG CONFIRMAÇÃO DELETE PATIENT */}
                <Dialog
                    open={this.state.openDialogConfirmDeletePatient || this.state.openDialogConfirmDeleteEpisode}
                    className='admin-modals'
                    aria-labelledby='alert-dialog-title'
                    aria-describedby='alert-dialog-description'
                >
                    <DialogTitle id='alert-dialog-title' className='px-4'>
                        {this.state.openDialogConfirmDeletePatient ? t('DeletePatient') : t('DeleteEpisode')}?
                    </DialogTitle>
                    <DialogContent className='py-0 px-4'>
                        <DialogContentText id='alert-dialog-reset-password'>
                            {this.state.openDialogConfirmDeletePatient ? t('confirmMsgDeletePatient') : t('confirmMsgDeleteEpisode')}
                            <br />
                            {this.state.openDialogConfirmDeleteEpisode ? t('cannotRevertAction') : ''}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions className='pt-0 pr-4'>
                        <Button
                            className='outline-none text-capitalize'
                            onClick={(v) => this.closeDialogDelete()}
                            color='#494949'
                            autoFocus
                            disableFocusRipple
                            disableRipple
                        >
                            {t('goBack')}
                        </Button>
                        <Button
                            className='outline-none text-capitalize'
                            onClick={(v) => this.state.openDialogConfirmDeletePatient ? this.onDeletePatientConfirm() : this.onDeleteEpisodeConfirm()}
                            color='primary'
                            disableFocusRipple
                            disableRipple
                        >
                            {this.state.openDialogConfirmDeletePatient ? t('DeletePatient') : t('DeleteEpisode')}
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Mensagem de alterações gravadas com sucesso */}
                <Snackbar
                    open={this.state.showSucessMessage}
                    autoHideDuration={5000}
                    onClose={this.handleCloseSnackBar}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                >
                    <MuiAlert
                        elevation={6}
                        variant='filled'
                        onClose={this.handleCloseSnackBar}
                        severity='success'
                    >
                        {t(this.state.sucessMessage)}
                    </MuiAlert>
                </Snackbar>

                {/* Mensagem de Erro */}
                <Snackbar
                    open={this.state.showErrorMessage}
                    autoHideDuration={5000}
                    onClose={this.handleCloseSnackBar}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                >
                    <MuiAlert
                        elevation={6}
                        variant='filled'
                        onClose={this.handleCloseSnackBar}
                        severity='error'
                    >
                        {t(this.state.errorMessage)}
                    </MuiAlert>
                </Snackbar>

                <BackToTop iddiv={'#back-to-top-patients-list'}></BackToTop>
            </>
        );
    }
}

const mapStateToProps = (state) => ({ login: state.login, wounds: state.wounds, patientsManage: state.patientsManage });
const mapDispatchToProps = (dispatch) => bindActionCreators({ getPatientsManagementSearch, setLoading, getPatientInfoManagement, getURItoUploadPhotoPatient, createPatient, updatePatient, getEstablishments, deletePatient, deleteEpisode, deleteEpisodeAndInternment }, dispatch);

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(PatientsList));
